import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DLCompany } from './company';
import { lookupParam } from '../../nav/utils';
import { NotifierService } from '../../ui';
import { DLLedgerService } from './ledger.service';

@Injectable()
export class DLLedgerResolver implements Resolve<DLCompany> {

  constructor(
    private router: Router,
    private ledgerService: DLLedgerService,
    private notifier: NotifierService,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): DLCompany | Observable<DLCompany> | Promise<DLCompany> {
    return new Promise<DLCompany>(async (resolve, reject) => {

      let company_id = lookupParam(route, 'company_id');
      let ledger_id = lookupParam(route, 'ledger_id');

      this.notifier.startProgress();

      this.ledgerService
        .ledger(company_id, ledger_id)
        .subscribe((company) => {
          
          if(company) {
            return resolve(company);
          }
          else {
            this.router.navigate(['documents-ledger', 'companies']);
            return resolve(null);
          }
        });
    });
  }
}